import React from 'react';

import FeaturesTab from '~/components/SystemConfiguration/FeaturesTab';
import Switch from '~/components/ui/atoms/Switch';

interface Feature {
  name: string;
  display_name: string;
  description: string;
  category: string;
  enabled_by_default: boolean;
  editable_by_support: boolean;
  enabled_by_default_for_demo: boolean;
}

interface CliveRelatedCmsFeatureFlagsTableProps {
  additionalFilter?: (feature: Feature) => boolean;
  withDemoFeaturesSwitch?: boolean;
}

const CliveRelatedCmsFeatureFlagsTable: React.FC<CliveRelatedCmsFeatureFlagsTableProps> = ({
  additionalFilter,
  withDemoFeaturesSwitch = true,
}) => {
  const [showDemoFFs, setShowDemoFFs] = React.useState(!withDemoFeaturesSwitch);

  const cliveFilter = (feature: Feature) =>
    (feature.name.toLowerCase().includes('clive') ||
      feature.display_name.toLowerCase().includes('clive') ||
      feature.description.toLowerCase().includes('clive')) &&
    (additionalFilter ? additionalFilter(feature) : true) &&
    (!showDemoFFs ? !(feature.display_name + feature.description).toLowerCase().includes('demo') : true);

  return (
    <FeaturesTab
      filter={cliveFilter}
      additionalFilterComponent={
        withDemoFeaturesSwitch ? (
          <div className="ml-24 flex w-full gap-8">
            <span className="w-max">Show Demo Features</span>
            <Switch onChange={() => setShowDemoFFs(!showDemoFFs)} checked={showDemoFFs} disabled={false} />
          </div>
        ) : null
      }
    />
  );
};

export default CliveRelatedCmsFeatureFlagsTable;
